import { connect } from 'react-redux';

const mapStateToProps = (state) => ({
  user: state.user,
  interactive: state.interactive,
});

const mapDispatchToProps = (dispatch) => ({
  onLogin: (user) => {
    sessionStorage.setItem('user', JSON.stringify(user));
    dispatch({ type: 'SET_USER', user });
  },
  onStart: () => {
    dispatch({
      type: 'RESET_INTERACTIVE',
    });
  },
  alertUser: () => {
    dispatch({
      type: 'ALERT_USER',
      alert: true,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
);
